import { connect } from "react-redux";
import RecordingComponent from "../../Components/RecordingsManagement/RecordingComponent";

const mapStateToProps = (state) => ({
  callFlows: state.reducer.CALL_FLOWS,
  supervisedAgentDetails: state.reducer.supervisedAgentDetails,
  supervisedAgentIds: state.reducer.supervisedAgentIds,
  callFlowsIds: state.reducer.callFlowsIds,
  tenantId: state.reducer.ACTIVE_TENANT,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RecordingComponent);
